import {
    PRECIO_JUSTO_GET_CONFIGURATIONS_BEGIN,
    PRECIO_JUSTO_GET_CONFIGURATIONS_SUCCESS,
    PRECIO_JUSTO_GET_CONFIGURATIONS_FAILURE
} from './constants'
import { BFFAgent } from 'BFFAgent'

export function getConfigurations() {
    return async dispatch => {
        dispatch({
            type: PRECIO_JUSTO_GET_CONFIGURATIONS_BEGIN
        })
        const res = await BFFAgent.FairPrice.getConfigurations()
        
        if (res?.length)
            dispatch({
                type: PRECIO_JUSTO_GET_CONFIGURATIONS_SUCCESS,
                configuration: res[0]
            })
        else
            dispatch({
                type: PRECIO_JUSTO_GET_CONFIGURATIONS_FAILURE
            })
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case PRECIO_JUSTO_GET_CONFIGURATIONS_BEGIN:
            return {
                ...state,
                actConfigurationError: null,
            }
        case PRECIO_JUSTO_GET_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                actConfiguration: action.configuration,
                actConfigurationError: null,
            }
        case PRECIO_JUSTO_GET_CONFIGURATIONS_FAILURE:
            return {
                ...state,
                actConfigurationError: true,
            }

        default:
            return state
    }
}
